import isString from './isString';
import isFunction from './isFunction';

/**
 * check if item contains in some array
 *
 * @export
 * @param {Array|String} etalon array
 * @param {Function|String} cond condition
 * @returns {Boolean} `true` if item contains in array
 */
export default function contains(etalon, cond) {
   if (isString(etalon) && isString(cond)) {
      return _containsInString(etalon, cond);
   }
   const condFnc = isFunction(cond) ? cond : obj => obj === cond;
   return _containsInArray(etalon, condFnc);
}

function _containsInString(string, substring) {
   // eslint-disable-next-line no-magic-numbers
   return string.indexOf(substring) > -1;
}

function _containsInArray(array, cond) {
   for (let i = 0; i < array.length; i++) {
      if (cond(array[i])) {
         return true;
      }
   }

   return false;
}
